import { useState } from 'react';
import LayoutHeader from './components/LayoutHeader';
import LayoutFooter from './components/LayoutFooter';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import CatalogoPage from './pages/CatalogoPage';
import DepartmentPage from './pages/DepartmentPage';
import ScrollToTopButton from './components/ScrollToTopButton'; // Importar el botón
import NewsPage from './pages/NewsPage'; // Importar la nueva página de novedades

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [currentDepartmentName, setDepartmentName] = useState(''); // Estado para el nombre del departamento

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage setCurrentPage={setCurrentPage} setDepartmentName={setDepartmentName} />; // Pasa setDepartmentName
      case 'about':
        return <AboutPage />;
      case 'services':
        return <ServicesPage setCurrentPage={setCurrentPage} setDepartmentName={setDepartmentName} />;
      case 'news': // Nueva ruta para la página de novedades
        return <NewsPage />;
      case 'contact':
        return <ContactPage />;
      case 'catalogo':
        return <CatalogoPage />;
      case 'department':
        return <DepartmentPage departmentName={currentDepartmentName} setCurrentPage={setCurrentPage} />;
      default:
        return <HomePage setCurrentPage={setCurrentPage} setDepartmentName={setDepartmentName} />;
    }
  };

  return (
    <div className="font-sans bg-white">
      <LayoutHeader setCurrentPage={setCurrentPage} />
      {renderPage()}
      <LayoutFooter setCurrentPage={setCurrentPage}/>
      <ScrollToTopButton />
    </div>
  );
};
export default App;

// DONE